<template>
  <div class="ariaUpdates" aria-live="assertive" aria-atomic="true">
    <div id="appliedFiltersContainer">
      <span class="visuallyHidden">Filtered by </span>
      <button
        v-for="filter in filters"
        :key="filter"
        @click="remove(filter)"
        class="appliedFilterButton"
        :value="filter"
      >
        {{ filter }}
      </button>
    </div>
    <!-- <span id="filteredAnnouncement" class="sr-only">There are now 3 out of 21 items displayed.</span> -->
  </div>
</template>

<script>
export default {
  name: "AppliedFilters",
  props: {
    filters: Array,
  },
  methods: {
    remove(filter) {
      // console.log('removing', filter)
      this.$emit('remove', filter)
    },
  },
};
</script>

<style scoped lang="scss"></style>
